/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { RouteRecordRaw } from "vue-router";
import InboxSidebar from "../views/inbox/Sidebar.vue";
import InboxSettingsSidebar from "../views/inbox/settings/Sidebar.vue";

export const InboxRoutes = [
  {
    path: "/inbox/:chatbotId",
    name: "InboxMain",
    components: {
      default: () =>
        import(/* webpackChunkName: "inbox" */ "../views/inbox/Main.vue"),
      sidenav: InboxSidebar,
    },
  },
  {
    path: "/inbox/:chatbotId/:view",
    name: "InboxView",
    components: {
      default: () =>
        import(/* webpackChunkName: "inbox" */ "../views/inbox/Main.vue"),
      sidenav: InboxSidebar,
    },
  },
  {
    path: "/inbox/:chatbotId/:view/:conversationId",
    name: "InboxConversation",
    components: {
      default: () =>
        import(/* webpackChunkName: "inbox" */ "../views/inbox/Main.vue"),
      sidenav: InboxSidebar,
    },
  },
  //Settings
  {
    path: "/inbox/:chatbotId/settings/answers",
    name: "InboxSettingsAnswers",
    components: {
      default: () =>
        import(
          /* webpackChunkName: "inbox-settings" */ "../views/inbox/settings/Answers.vue"
        ),
      sidenav: InboxSettingsSidebar,
    },
  },
  {
    path: "/inbox/:chatbotId/settings/views",
    name: "InboxSettingsViews",
    components: {
      default: () =>
        import(
          /* webpackChunkName: "inbox-settings" */ "../views/inbox/settings/Views.vue"
        ),
      sidenav: InboxSettingsSidebar,
    },
  },
  {
    path: "/inbox/:chatbotId/settings/fields",
    name: "InboxSettingsFields",
    components: {
      default: () =>
        import(
          /* webpackChunkName: "inbox-settings" */ "../views/inbox/settings/Fields.vue"
        ),
      sidenav: InboxSettingsSidebar,
    },
  },
  {
    path: "/inbox/:chatbotId/settings/tags",
    name: "InboxSettingsTags",
    components: {
      default: () =>
        import(
          /* webpackChunkName: "inbox-settings" */ "../views/inbox/settings/Tags.vue"
        ),
      sidenav: InboxSettingsSidebar,
    },
  },
] as RouteRecordRaw[];
